export default "__VITE_ASSET__BsCs42T$__"